import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
import { Container, TextField, Button, Typography, Box, Snackbar } from '@mui/material';
import { useGetTokenMutation } from '../services/auth';
import { setOpenLogin } from '../features/authSlice';
import logo from '../images/logo_triumph.png';
import bgFYB from '../images/bgFYB.png';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

function Login(props) {
  const dispatch = useDispatch()
  // const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [getToken, result] = useGetTokenMutation();
  const [alert, setAlert] = useState(false);

  useEffect(()=>{
    const strLogin = window.localStorage.getItem('login');
    if(strLogin){
      const user = JSON.parse(atob(strLogin));
      setUsername(user.USERNAME);
      setPassword(user.PASSWORD);
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const userData = { "USERNAME": username, "PASSWORD": password };
    const loginResult = await getToken(userData).unwrap().catch((e) => { console.log(e); });
    if (loginResult) {
      window.localStorage.setItem('login', btoa(JSON.stringify(userData)));
      // navigate('/');
      if(props.modal)
        dispatch(setOpenLogin(false));
      else{
        window.location.href = `${BASE_NAME}/home`;
      }
    }
    else{
      setAlert(true);
    }
  };

  return (
    <Container component="main" maxWidth="xs"
      sx={{ 
        minHeight: '100vh', 
        backgroundImage: `url(${bgFYB})`,
        backgroundSize: '100% 100%', //(e.g., ''cover', 'contain', '100% 100%')
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box component="img" src={logo} sx={{ mt: 8, width: 200 }} />
        {/* <Typography component="h1" variant="h5">
          Sign In
        </Typography> */}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username or Email"
            name="username"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            loading={result.isLoading}
          >
            Sign In
          </Button>
        </Box>
      </Box>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message="Incorect username and password!"
        // action={action}
      />
    </Container>
  );
}

export default Login;